import React, { useState, useMemo, useEffect } from 'react';
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  TableSortLabel,
  Box,
  useMediaQuery,
  Snackbar,
  Alert,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
  CircularProgress,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import UndoIcon from '@mui/icons-material/Undo';
import HistoryIcon from '@mui/icons-material/History';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { getcashsales } from '../redux/cashsales';
import { getstock } from '../redux/stock';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { getagent } from '../redux/agent';

const theme = createTheme({
  palette: {
    primary: { main: '#1976d2' },
    secondary: { main: '#dc004e' },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '8px',
          fontSize: '0.875rem',
        },
      },
    },
  },
});

function StockSalesManagement() {
  const dispatch = useDispatch();
  const sales_ = useSelector((state) => state.cashsales || []);
  const stock_ = useSelector((state) => state.stock || []);
  const agents_ = useSelector((state) => state.agent || []);
  const admin = useSelector((state) => state.admin);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

console.log("agents_")
console.log(agents_)
console.log(sales_)

  // State management
  const [view, setView] = useState('sales');
  const [stocks, setStocks] = useState(stock_);
  const [sales, setSales] = useState(sales_);
  const [newSale, setNewSale] = useState({ 
    products: [{ productId: '', quantity: '' }],
    date: '',
    receipt: '',
    sender: '', 
    company: '', 
    transaction: '', 
    bank: '', 
    account: '',
    payment: '',
    agent: 'main_office'
  });
  const [newStock, setNewStock] = useState({ name: '', purchasePrice: '', sellingPrice: '', quantity: '' });
  const [editingSale, setEditingSale] = useState(null);
  const [editingStock, setEditingStock] = useState(null);
  const [payment, setPayment] = useState('');
  const [product, setProduct] = useState('');
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [assignmentLoading, setAssignmentLoading] = useState(false);
  const [recordSaleLoading, setRecordSaleLoading] = useState(false);
  const [cancelAssignmentLoading, setCancelAssignmentLoading] = useState(false);
  const [editAssignmentLoading, setEditAssignmentLoading] = useState(false);
  const [selectedStockHistory, setSelectedStockHistory] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // New state variables for agent functionality
  const [selectedAgent, setSelectedAgent] = useState('');
  const [stockAssignments, setStockAssignments] = useState([]);
  const [assignmentStatus, setAssignmentStatus] = useState('pending'); // pending, confirmed, rejected, returned

  // Add new state for assignment history
  const [assignmentHistory, setAssignmentHistory] = useState([]);
  const [showAssignmentDialog, setShowAssignmentDialog] = useState(false);
  const [selectedStockForAssignment, setSelectedStockForAssignment] = useState(null);
  const [assignmentQuantity, setAssignmentQuantity] = useState('');
  const [assignmentNotes, setAssignmentNotes] = useState('');

  // Add new state for assignment history modal
  const [showAssignmentHistoryModal, setShowAssignmentHistoryModal] = useState(false);

  // Add new state for edit assignment modal
  const [showEditAssignmentModal, setShowEditAssignmentModal] = useState(false);
  const [editingAssignment, setEditingAssignment] = useState(null);

  // Add new state for sorting
  const [sortConfig, setSortConfig] = useState({
    key: 'agentName',
    direction: 'asc'
  });

  // Add new state for pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Add new state for delete loading
  const [deleteStockLoading, setDeleteStockLoading] = useState({});

  // Add new state for delete confirmation dialog
  const [deleteConfirmDialog, setDeleteConfirmDialog] = useState({
    open: false,
    stockId: null,
    stockName: '',
    hasSales: false
  });

  // Add new state for sales sorting
  const [salesSortConfig, setSalesSortConfig] = useState({
    key: 'date',
    direction: 'desc'
  });

  // Add new state for filters
  const [salesFilters, setSalesFilters] = useState({
    agent: '',
    product: '',
    startDate: '',
    endDate: ''
  });

  // Add new state for assignment date filters
  const [assignmentDateFilters, setAssignmentDateFilters] = useState({
    startDate: '',
    endDate: ''
  });

  // Memoized calculations
  const totalSales = useMemo(() => {
    return sales.reduce((sum, sale) => {
      // Calculate total for each sale by summing up all products
      const saleTotal = sale.products.reduce((productSum, product) => {
        const quantity = parseInt(product.quantity) || 0;
        const price = parseFloat(product.price) || 0;
        return productSum + (quantity * price);
      }, 0);
      return sum + saleTotal;
    }, 0);
  }, [sales]);

  const totalStockValue = useMemo(() => stocks.reduce((sum, stock) => sum + ((stock.quantity ?stock.quantity:0) * (stock.purchasePrice ? stock.purchasePrice:0)), 0), [stocks]);

  // Handlers
  const handleSaleInput = (e) => setNewSale({ ...newSale, [e.target.name]: e.target.value });
  const handleStockInput = (e) => setNewStock({ ...newStock, [e.target.name]: e.target.value });
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const resetSaleForm = () => {
    setNewSale({ 
      products: [{ productId: '', quantity: '' }],
      date: '',
      receipt: '',
      sender: '', 
      company: '', 
      transaction: '', 
      bank: '', 
      account: '',
      payment: '',
      agent: 'main_office'
    });
    setEditingSale(null);
  };

  const resetStockForm = () => {
    setNewStock({ name: '', purchasePrice: '', sellingPrice: '', quantity: '' });
    setEditingStock(null);
  };

  // Add function to handle multiple products
  const addProductToSale = () => {
    setNewSale(prev => ({
      ...prev,
      products: [...prev.products, { productId: '', quantity: '' }]
    }));
  };

  const removeProductFromSale = (index) => {
    setNewSale(prev => ({
      ...prev,
      products: prev.products.filter((_, i) => i !== index)
    }));
  };

  const handleProductInput = (index, field, value) => {
    setNewSale(prev => ({
      ...prev,
      products: prev.products.map((product, i) => 
        i === index ? { ...product, [field]: value } : product
      )
    }));
  };

  const addSale = async (e) => {
    e.preventDefault();
    setAddLoading(true);

    // Validate all products
    for (const product of newSale.products) {
      const stock = stocks.find(s => parseInt(s.id) === parseInt(product.productId));
      if (!stock) {
        setSnackbarMessage('Please select valid products.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setAddLoading(false);
        return;
      }

      const quantity = parseInt(product.quantity);
      if (isNaN(quantity) || quantity <= 0) {
        setSnackbarMessage('Please enter valid quantities for all products.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setAddLoading(false);
        return;
      }
      if (stock.quantity < quantity) {
        setSnackbarMessage(`Insufficient stock quantity for ${stock.name}.`);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setAddLoading(false);
        return;
      }
    }

    const saleProducts = newSale.products.map(product => {
      const stock = stocks.find(s => parseInt(s.id) === parseInt(product.productId));
      return {
        productId: product.productId,
        productName: stock.name,
        quantity: parseInt(product.quantity),
        price: stock.sellingPrice
      };
    });

    const sale = {
      id: Date.now(),
      agent: newSale.agent === 'main_office' ? 'Main Office' : agents_.find(a => a.id === newSale.agent)?.name || 'Unknown Agent',
      agentId: newSale.agent,
      products: saleProducts,
      payment: newSale.payment,
      date: newSale.date,
      receipt: newSale.receipt || '',
      sender: newSale.sender || '',
      company: newSale.company || '',
      transaction: newSale.transaction || '',
      bank: newSale.bank || '',
      account: newSale.account || '',
    };

    try {
      // Update stock quantities
      const stockUpdates = saleProducts.map(product => ({
        id: product.productId,
        quantity: stocks.find(s => parseInt(s.id) === parseInt(product.productId)).quantity - product.quantity
      }));
console.log("sale")
console.log(sale)
      const response = await axios.post('https://server.agrotraciserp.com/api/cashsales/addcashsales/', {
        sales: [sale],
        stock: stockUpdates
      });

      if (response.status === 200) {
        setSales(prev => [...prev, sale]);
        // Update stock quantities
        saleProducts.forEach(product => {
          updateStock(product.productId, -product.quantity);
        });
        dispatch(getcashsales({ data: response.data }));
        setSnackbarMessage('Sale added successfully');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        resetSaleForm();
      } else {
        setSnackbarMessage('Failed to add sale');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage('Error adding sale');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setAddLoading(false);
    }
  };

  const editSale = (sale) => {
    setEditingSale(sale);
    setNewSale({
      products: [{
        productId: sale.productId || '',
        quantity: sale.quantity || '',
        price: sale.price || ''
      }],
      date: sale.date || '',
      receipt: sale.receipt || '',
      sender: sale.sender || '',
      company: sale.company || '',
      transaction: sale.transaction || '',
      bank: sale.bank || '',
      account: sale.account || '',
      payment: sale.payment || '',
      agent: sale.agentId || 'main_office'
    });
    setProduct(sale.productId);
    setPayment(sale.payment);
    setOpenEditSaleDialog(true);
  };

  const updateSale = async (e) => {
    e.preventDefault();
    setUpdateLoading(true);

    const stock = stocks.find((s) =>  parseInt( s.id) === parseInt(product));


    if (!stock) {
      setSnackbarMessage('Please select a valid product.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setUpdateLoading(false);
      return;
    }

    const oldSale = sales.find((s) => s.id === editingSale.id);
    const quantity = parseInt(newSale.quantity);
    const quantityDiff = quantity - oldSale.quantity;

    if (isNaN(quantity) || quantity <= 0) {
      setSnackbarMessage('Please enter a valid quantity.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setUpdateLoading(false);
      return;
    }
    if (stock.quantity < quantityDiff) {
      setSnackbarMessage('Insufficient stock quantity.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setUpdateLoading(false);
      return;
    }

    const updatedSale = {
      ...editingSale,
      productId: product,
      productName: stock.name,
      quantity: quantity,
      payment: payment,
      price: stock.sellingPrice,
      date: newSale.date,
      receipt: newSale.receipt || '',
      sender: newSale.sender || '',
      company: newSale.company || '',
      transaction: newSale.transaction || '',
      bank: newSale.bank || '',
      account: newSale.account || '',
    };

    try {
      const stockdata = { quantity: stock.quantity - quantityDiff, id: stock.id };
      const response = await axios.post('https://server.agrotraciserp.com/api/cashsales/editcashsales/', {
        sales: updatedSale,
        stock: stockdata,
      });

      if (response.status === 200) {
        setSales((prev) => prev.map((s) => (s.id === editingSale.id ? updatedSale : s)));
        updateStock(product, -quantityDiff);
        dispatch(getcashsales({ data: response.data }));
        setSnackbarMessage('Sale updated successfully');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        resetSaleForm();
      } else {
        setSnackbarMessage('Failed to update sale');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage('Error updating sale');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUpdateLoading(false);
    }
  };

  const deleteSale = (id) => {
    const saleToDelete = sales.find(s => s.id === id);
    if (!saleToDelete) {
        setSnackbarMessage('Sale not found');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        return;
    }
    setDeleteSaleDialog({
        open: true,
        saleId: id,
        saleDetails: saleToDelete
    });
};

const handleDeleteSale = async () => {
    if (!deleteSaleDialog.saleId) return;
    setDeleteLoading(true);
    
    try {
        // Get the sale to delete
        const saleToDelete = sales.find(s => s.id === deleteSaleDialog.saleId);
        if (!saleToDelete) {
            throw new Error('Sale not found');
        }

        // Prepare stock updates for each product in the sale
        const stockUpdates = saleToDelete.products.map(product => ({
            id: product.productId,
            quantity: stocks.find(s => s.id === product.productId)?.quantity + parseInt(product.quantity)
        }));

        const response = await axios.post('https://server.agrotraciserp.com/api/cashsales/deletecashsales/', {
            id: saleToDelete.id,
            stock: stockUpdates
        });

        if (response.status === 200) {
            // Update local state
            setSales(prev => prev.filter(s => s.id !== deleteSaleDialog.saleId));
            
            // Update stock quantities using state setter
            setStocks(prev => prev.map(stock => {
                const update = stockUpdates.find(u => u.id === stock.id);
                if (update) {
                    return { ...stock, quantity: update.quantity };
                }
                return stock;
            }));
            
            // Update both Redux stores
            dispatch(getcashsales({ data: response.data }));
            
            // Update stock in Redux
            const updatedStocks = stocks.map(stock => {
                const update = stockUpdates.find(u => u.id === stock.id);
                if (update) {
                    return { ...stock, quantity: update.quantity };
                }
                return stock;
            });
            dispatch(getstock({ data: updatedStocks }));
            
            setSnackbarMessage('Sale deleted successfully');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
        } else {
            throw new Error('Failed to delete sale');
        }
    } catch (error) {
        console.error('Error deleting sale:', error);
        setSnackbarMessage(error.response?.data?.message || 'Error deleting sale');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
    } finally {
        setDeleteLoading(false);
        setDeleteSaleDialog({ open: false, saleId: null, saleDetails: null });
    }
};

  const addStock = async (e) => {
    if (e && e.preventDefault) {
    e.preventDefault();
    }

    setAddLoading(true);

    const stock = {
      id: Date.now(),
      name: newStock.name,
      purchasePrice: parseFloat(newStock.purchasePrice),
      sellingPrice: parseFloat(newStock.sellingPrice),
      quantity: parseInt(newStock.quantity),
      history: [{
        date: new Date().toISOString().split('T')[0],
        quantity: parseInt(newStock.quantity),
        type: 'add'
      }],
    };

    try {
      const response = await axios.post('https://server.agrotraciserp.com/api/stock/addstock/', {stock} );
      if (response.status === 200) {
        setStocks((prev) => [...prev, stock]);
        dispatch(getstock({ data: response.data }));
        setSnackbarMessage('Stock added successfully');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        resetStockForm();
        handleCloseStockDialog();
      } else {
        setSnackbarMessage('Failed to add stock');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage('Error adding stock');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setAddLoading(false);
    }
  };

  const editStock = (stock) => {
    setEditingStock(stock);
    setNewStock({
      name: stock.name,
      purchasePrice: stock.purchasePrice,
      sellingPrice: stock.sellingPrice,
      quantity: stock.quantity,
    });
    setOpenStockDialog(true); // Open the modal when editing
  };

  const updateStock = async (e) => {
    // Only prevent default if event exists (form submission)
    if (e && e.preventDefault) {
    e.preventDefault();
    }
    
    if (!editingStock) {
      setSnackbarMessage('No stock selected for editing');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    setUpdateLoading(true);

    const updatedStock = {
      ...editingStock,
      name: newStock.name,
      purchasePrice: parseFloat(newStock.purchasePrice),
      sellingPrice: parseFloat(newStock.sellingPrice),
      quantity: parseInt(newStock.quantity),
      history: [
        ...(editingStock.history || []),
        {
          date: new Date().toISOString().split('T')[0],
          quantity: Math.abs(parseInt(newStock.quantity) - editingStock.quantity),
          type: parseInt(newStock.quantity) > editingStock.quantity ? 'add' : 'update',
        },
      ],
    };
    
    
    try {
      const response = await axios.post('https://server.agrotraciserp.com/api/stock/editstock/', { 
        _id: editingStock._id,
        stock: updatedStock 
      });
      
      if (response.status === 200) {
        setStocks((prev) => prev.map((s) => (s.id === editingStock.id ? updatedStock : s)));
        dispatch(getstock({ data: response.data }));
        setSnackbarMessage('Stock updated successfully');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        resetStockForm();
        handleCloseStockDialog();
      } else {
        setSnackbarMessage('Failed to update stock');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage('Error updating stock');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUpdateLoading(false);
    }
  };

  const deleteStock = async (id, prodid) => {
    const stock = stocks.find(s => s.id === prodid);
    const hasSales = sales.some((sale) => sale.productId === prodid);
    
    if (hasSales) {
      setDeleteConfirmDialog({
        open: true,
        stockId: id,
        stockName: stock.name,
        hasSales: true
      });
      return;
    }

    // If no sales history, proceed with deletion
    handleDeleteStock(id, prodid);
  };

  // Add new function to handle actual deletion
  const handleDeleteStock = async (id, prodid) => {
    setDeleteStockLoading(prev => ({ ...prev, [prodid]: true }));
    
    try {
      const response = await axios.post('https://server.agrotraciserp.com/api/stock/deletestock/', { 
        id,
        deleteSales: deleteConfirmDialog.hasSales
      });
      
      if (response.status === 200) {
        setStocks((prev) => prev.filter((s) => s.id !== prodid));
        if (deleteConfirmDialog.hasSales) {
          setSales((prev) => prev.filter((s) => s.productId !== prodid));
        }
        dispatch(getstock({ data: response.data }));
        setSnackbarMessage('Stock deleted successfully');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      } else {
        setSnackbarMessage('Failed to delete stock');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage('Error deleting stock');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setDeleteStockLoading(prev => ({ ...prev, [prodid]: false }));
      setDeleteConfirmDialog({
        open: false,
        stockId: null,
        stockName: '',
        hasSales: false
      });
    }
  };

  const updateStockQuantity = (stockId, quantityChange) => {
    setStocks((prev) =>
      prev.map((stock) => {
        if (stock.id === stockId) {
          const newQuantity = stock.quantity + quantityChange;
          const historyEntry = {
            date: new Date().toISOString().split('T')[0],
            quantity: Math.abs(quantityChange),
            type: quantityChange > 0 ? 'add' : 'sale',
          };
          return { ...stock, quantity: newQuantity, history: [...stock.history, historyEntry] };
        }
        return stock;
      })
    );
  };

  // Add function to get full agent name
  const getAgentFullName = (agentId) => {
    const agent = agents_.find(a => a._id === agentId);
    if (!agent) return 'Unknown Agent';
    return `${agent.surname || ''} ${agent.lastname || ''} ${agent.othername || ''}`.trim() || agent.name || 'Unknown Agent';
  };

  const calculateSaleTotal = (sale) => {
    if (sale.products && Array.isArray(sale.products)) {
      return sale.products.reduce((total, product) => {
        return total + (product.quantity * product.price);
      }, 0);
    }
    return 0;
  };

  const getFilteredSales = () => {
    console.log("Sales data:", sales);
    return sales.filter(sale => {
      if (!startDate && !endDate) return true;
      const saleDate = new Date(sale.date);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;
      
      if (start && end) {
        end.setHours(23, 59, 59);
        return saleDate >= start && saleDate <= end;
      } else if (start) {
        return saleDate >= start;
      } else if (end) {
        end.setHours(23, 59, 59);
        return saleDate <= end;
      }
      return true;
    }).sort((a, b) => new Date(b.date) - new Date(a.date));
  };

  // Enhanced assignStockToAgent function
  const assignStockToAgent = async (stockId, quantity) => {
    setAssignmentLoading(true);
    if (!selectedAgent || quantity <= 0) {
      setSnackbarMessage('Please select an agent and enter valid quantity');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setAssignmentLoading(false);
      return;
    }

    const stock = stocks.find(s => s.id === stockId);
    if (!stock || stock.quantity < quantity) {
      setSnackbarMessage('Insufficient stock quantity');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setAssignmentLoading(false);
      return;
    }

    try {
      const response = await axios.post('https://server.agrotraciserp.com/api/stock/assignstock/', {
        stockId,
        agentId: selectedAgent,
        quantity: parseInt(quantity),
        notes: assignmentNotes
      });

      if (response.status === 200) {
        // Update local state with the response data
        const updatedStock = response.data;
        setStocks(prev => prev.map(s => s.id === stockId ? updatedStock : s));
        
        // Add to assignments list
        const newAssignment = updatedStock.assignments[updatedStock.assignments.length - 1];
        setStockAssignments(prev => [...prev, newAssignment]);
        setAssignmentHistory(prev => [...prev, newAssignment]);
        
        setSnackbarMessage('Stock assigned successfully');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        
        // Reset form
        setSelectedStockForAssignment(null);
        setAssignmentQuantity('');
        setAssignmentNotes('');
        setShowAssignmentDialog(false);
      } else {
        setSnackbarMessage('Failed to assign stock');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage('Error assigning stock');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setAssignmentLoading(false);
    }
  };

  // Enhanced handleAssignmentResponse function
  const handleAssignmentResponse = async (assignmentId, status, reason = '') => {
    const assignment = stockAssignments.find(a => a.id === assignmentId);
    if (!assignment) return;

    try {
      const response = await axios.post('https://server.agrotraciserp.com/api/stock/updateassignment/', {
        stockId: assignment.stockId,
        assignmentId,
        status,
        notes: reason
      });

      if (response.status === 200) {
        const updatedStock = response.data;
        
        // Update stock state
        setStocks(prev => prev.map(s => s.id === assignment.stockId ? updatedStock : s));
        
        // Update assignments
        const updatedAssignment = updatedStock.assignments.find(a => a.id === assignmentId);
        if (updatedAssignment) {
          setStockAssignments(prev => prev.map(a => a.id === assignmentId ? updatedAssignment : a));
          setAssignmentHistory(prev => prev.map(a => a.id === assignmentId ? updatedAssignment : a));
        }
        
        setSnackbarMessage(`Assignment ${status} successfully`);
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      } else {
        setSnackbarMessage(`Failed to ${status} assignment`);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage(`Error updating assignment status`);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  // Add new function to view assignment history
  const renderAssignmentHistory = (stockId) => {
    const stockAssignments = assignmentHistory.filter(a => a.stockId === stockId);
    if (stockAssignments.length === 0) return null;

    return (
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2" gutterBottom>Assignment History</Typography>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Agent</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Notes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {stockAssignments.map((assignment) => (
                <TableRow key={assignment.id}>
                  <TableCell>{new Date(assignment.assignedAt).toLocaleDateString()}</TableCell>
                  <TableCell>{assignment.agentName}</TableCell>
                  <TableCell>{assignment.quantity}</TableCell>
                  <TableCell>
                    <Chip 
                      label={assignment.status}
                      color={
                        assignment.status === 'confirmed' ? 'success' :
                        assignment.status === 'pending' ? 'warning' :
                        assignment.status === 'rejected' ? 'error' :
                        'default'
                      }
                      size="small"
                    />
                  </TableCell>
                  <TableCell>{assignment.notes}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  // Add back the recordAgentSale function
  const recordAgentSale = async (assignmentId, quantity) => {
    setRecordSaleLoading(true);
    const assignment = stockAssignments.find(a => a.id === assignmentId);
    if (!assignment || assignment.status !== 'confirmed') {
      setSnackbarMessage('Invalid assignment or status');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setRecordSaleLoading(false);
      return;
    }

    if (quantity > assignment.quantity) {
      setSnackbarMessage('Sale quantity exceeds assigned quantity');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setRecordSaleLoading(false);
      return;
    }

    const sale = {
      id: Date.now(),
      productId: assignment.stockId,
      productName: assignment.stockName,
      quantity,
      price: stocks.find(s => s.id === assignment.stockId)?.sellingPrice || 0,
      date: new Date().toISOString(),
      agentId: assignment.agentId,
      agentName: assignment.agentName,
      assignmentId
    };

    try {
      const response = await axios.post('https://server.agrotraciserp.com/api/cashsales/addcashsales/', {
        sales: [...sales, sale]
      });

      if (response.status === 200) {
        setSales(prev => [...prev, sale]);
        // Update remaining quantity in assignment
        const updatedAssignment = {
          ...assignment,
          quantity: assignment.quantity - quantity,
          history: [
            ...assignment.history,
            {
              date: new Date().toISOString(),
              action: 'sale',
              quantity,
              notes: `Sold ${quantity} units`
            }
          ]
        };
        setStockAssignments(prev => 
          prev.map(a => a.id === assignmentId ? updatedAssignment : a)
        );
        setAssignmentHistory(prev => 
          prev.map(a => a.id === assignmentId ? updatedAssignment : a)
        );

        setSnackbarMessage('Sale recorded successfully');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage('Error recording sale');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setRecordSaleLoading(false);
    }
  };

  // Update the assignment dialog to use the correct agent ID field
  const renderAssignmentDialog = () => (
    <Dialog 
      open={showAssignmentDialog} 
      onClose={() => setShowAssignmentDialog(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Assign Stock to Agent</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <FormControl fullWidth margin="dense">
            <InputLabel>Select Agent</InputLabel>
            <Select
              value={selectedAgent}
              onChange={(e) => setSelectedAgent(e.target.value)}
              label="Select Agent"
            >
              {agents_.map(agent => (
                <MenuItem key={agent._id} value={agent._id}>
                  {`${agent.surname || ''} ${agent.lastname || ''} ${agent.othername || ''}`.trim() || agent.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            margin="dense"
            label="Quantity"
            type="number"
            value={assignmentQuantity}
            onChange={(e) => setAssignmentQuantity(e.target.value)}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Notes"
            multiline
            rows={3}
            value={assignmentNotes}
            onChange={(e) => setAssignmentNotes(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowAssignmentDialog(false)}>Cancel</Button>
        <Button 
          onClick={() => {
            if (selectedStockForAssignment && assignmentQuantity) {
              assignStockToAgent(selectedStockForAssignment, parseInt(assignmentQuantity));
            }
          }}
          variant="contained"
          color="primary"
          disabled={assignmentLoading}
        >
          {assignmentLoading ? 'Assigning...' : 'Assign'}
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Add function to handle assignment cancellation
  const handleCancelAssignment = async (assignmentId) => {
    setCancelAssignmentLoading(true);
    try {
      const assignment = stockAssignments.find(a => a.id === assignmentId);
      if (!assignment) return;

      // Return stock to inventory
      const stock = stocks.find(s => s.id === assignment.stockId);
      const updatedStock = {
        ...stock,
        quantity: stock.quantity + assignment.quantity,
        assignments: stock.assignments.filter(a => a.id !== assignmentId)
      };

      console.log("updatedStock");
      console.log(updatedStock);
      await axios.post('https://server.agrotraciserp.com/api/stock/editstock/', {
        stock: updatedStock
      });

      // Update local state
      setStocks(prev => prev.map(s => s.id === assignment.stockId ? updatedStock : s));
      setStockAssignments(prev => prev.filter(a => a.id !== assignmentId));
      setAssignmentHistory(prev => prev.filter(a => a.id !== assignmentId));

      setSnackbarMessage('Assignment cancelled successfully');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (error) {
      setSnackbarMessage('Error cancelling assignment');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setCancelAssignmentLoading(false);
    }
  };

  // Update the edit assignment modal
  const renderEditAssignmentModal = () => (
    <Dialog
      open={showEditAssignmentModal}
      onClose={() => {
        setShowEditAssignmentModal(false);
        setEditingAssignment(null);
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Edit Assignment</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <FormControl fullWidth margin="dense">
            <InputLabel>Agent</InputLabel>
            <Select
              value={editingAssignment?.agentId || ''}
              onChange={(e) => setEditingAssignment(prev => ({ ...prev, agentId: e.target.value }))}
              label="Agent"
            >
              {agents_.map(agent => (
                <MenuItem key={agent._id} value={agent._id}>
                  {`${agent.surname || ''} ${agent.lastname || ''} ${agent.othername || ''}`.trim() || agent.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            margin="dense"
            label="Quantity"
            type="number"
            value={editingAssignment?.quantity || ''}
            onChange={(e) => setEditingAssignment(prev => ({ ...prev, quantity: parseInt(e.target.value) }))}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Notes"
            multiline
            rows={3}
            value={editingAssignment?.notes || ''}
            onChange={(e) => setEditingAssignment(prev => ({ ...prev, notes: e.target.value }))}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          setShowEditAssignmentModal(false);
          setEditingAssignment(null);
        }}>
          Cancel
        </Button>
        <Button 
          onClick={() => {
            if (editingAssignment) {
              handleEditAssignment(
                editingAssignment.id,
                editingAssignment.quantity,
                editingAssignment.agentId,
                editingAssignment.notes
              );
              setShowEditAssignmentModal(false);
              setEditingAssignment(null);
            }
          }}
          variant="contained"
          color="primary"
          disabled={editAssignmentLoading}
        >
          {editAssignmentLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Update the handleEditAssignment function
  const handleEditAssignment = async (assignmentId, newQuantity, newAgentId, newNotes) => {
    setEditAssignmentLoading(true);
    try {
      const assignment = stockAssignments.find(a => a.id === assignmentId);
      if (!assignment) return;

      const stock = stocks.find(s => s.id === assignment.stockId);
      const quantityDiff = newQuantity - assignment.quantity;

      if (stock.quantity < quantityDiff) {
        setSnackbarMessage('Insufficient stock quantity');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setEditAssignmentLoading(false);
        return;
      }

      const updatedAssignment = {
        ...assignment,
        quantity: newQuantity,
        agentId: newAgentId,
        agentName: getAgentFullName(newAgentId),
        notes: newNotes,
        history: [
          ...assignment.history,
          {
            date: new Date().toISOString(),
            action: 'edited',
            quantity: newQuantity,
            notes: `Assignment updated: Quantity: ${newQuantity}, Agent: ${getAgentFullName(newAgentId)}`
          }
        ]
      };

      const updatedStock = {
        ...stock,
        quantity: stock.quantity - quantityDiff,
        assignments: stock.assignments.map(a => 
          a.id === assignmentId ? updatedAssignment : a
        )
      };

      await axios.post('https://server.agrotraciserp.com/api/stock/editstock/', {
        stock: updatedStock
      });

      // Update local state
      setStocks(prev => prev.map(s => s.id === assignment.stockId ? updatedStock : s));
      setStockAssignments(prev => prev.map(a => a.id === assignmentId ? updatedAssignment : a));
      setAssignmentHistory(prev => prev.map(a => a.id === assignmentId ? updatedAssignment : a));

      setSnackbarMessage('Assignment updated successfully');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (error) {
      setSnackbarMessage('Error updating assignment');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setEditAssignmentLoading(false);
    }
  };

  // Update the assignment history modal
  const renderAssignmentHistoryModal = () => (
    <Dialog
      open={showAssignmentHistoryModal}
      onClose={() => setShowAssignmentHistoryModal(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        Assignment History - {selectedStockHistory?.name}
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Agent</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Notes</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {assignmentHistory
                .filter(a => a.stockId === selectedStockHistory?.id)
                .map((assignment) => (
                  <TableRow key={assignment.id}>
                    <TableCell>
                      {new Date(assignment.assignedAt).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      {getAgentFullName(assignment.agentId)}
                    </TableCell>
                    <TableCell>{assignment.quantity}</TableCell>
                    <TableCell>
                      <Chip 
                        label={assignment.status}
                        color={
                          assignment.status === 'confirmed' ? 'success' :
                          assignment.status === 'pending' ? 'warning' :
                          assignment.status === 'rejected' ? 'error' :
                          'default'
                        }
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{assignment.notes}</TableCell>
                    <TableCell>
                      {assignment.status === 'pending' && (
                        <>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setEditingAssignment(assignment);
                              setShowEditAssignmentModal(true);
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => handleCancelAssignment(assignment.id)}
                          >
                            <CancelIcon fontSize="small" />
                          </IconButton>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowAssignmentHistoryModal(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );

  // Add pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Add sort handler for sales
  const handleSalesSort = (key) => {
    setSalesSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  // Add filter handler
  const handleFilterChange = (filterType, value) => {
    setSalesFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
    setPage(0); // Reset to first page when filter changes
  };

  // Modify getSortedSales to include filtering
  const getFilteredAndSortedSales = () => {
    let filteredSales = [...sales_];

    // Apply filters
    if (salesFilters.agent) {
      filteredSales = filteredSales.filter(sale => sale.agentId === salesFilters.agent);
    }
    if (salesFilters.product) {
      filteredSales = filteredSales.filter(sale => 
        sale.productName?.toLowerCase().includes(salesFilters.product.toLowerCase())
      );
    }
    if (salesFilters.startDate) {
      filteredSales = filteredSales.filter(sale => 
        new Date(sale.date) >= new Date(salesFilters.startDate)
      );
    }
    if (salesFilters.endDate) {
      const endDate = new Date(salesFilters.endDate);
      endDate.setHours(23, 59, 59);
      filteredSales = filteredSales.filter(sale => 
        new Date(sale.date) <= endDate
      );
    }

    // Apply sorting
    if (!salesSortConfig.key) return filteredSales;

    return filteredSales.sort((a, b) => {
      let aValue = a[salesSortConfig.key];
      let bValue = b[salesSortConfig.key];

      // Handle date sorting
      if (salesSortConfig.key === 'date') {
        aValue = new Date(a.date);
        bValue = new Date(b.date);
      }

      // Handle product name sorting
      if (salesSortConfig.key === 'productName') {
        aValue = a.productName?.toLowerCase() || '';
        bValue = b.productName?.toLowerCase() || '';
      }

      // Handle agent sorting
      if (salesSortConfig.key === 'agent') {
        const agentA = agents_.find(agent => agent._id === a.agentId);
        const agentB = agents_.find(agent => agent._id === b.agentId);
        
        const nameA = agentA ? `${agentA.surname || ''} ${agentA.lastname || ''} ${agentA.othername || ''}`.trim() || agentA.name || 'Unknown Agent' : 'Unknown Agent';
        const nameB = agentB ? `${agentB.surname || ''} ${agentB.lastname || ''} ${agentB.othername || ''}`.trim() || agentB.name || 'Unknown Agent' : 'Unknown Agent';
        
        aValue = nameA.toLowerCase();
        bValue = nameB.toLowerCase();
      }

      if (aValue < bValue) {
        return salesSortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return salesSortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  };

  // Modify the sales table to include filters
  const renderSalesTable = () => (
    <>
      <Box sx={{ mb: 2, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Filter by Agent</InputLabel>
          <Select
            value={salesFilters.agent}
            onChange={(e) => handleFilterChange('agent', e.target.value)}
            label="Filter by Agent"
          >
            <MenuItem value="">All Agents</MenuItem>
            {agents_.map(agent => (
              <MenuItem key={agent._id} value={agent._id}>
                {`${agent.surname || ''} ${agent.lastname || ''} ${agent.othername || ''}`.trim() || agent.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Filter by Product"
          value={salesFilters.product}
          onChange={(e) => handleFilterChange('product', e.target.value)}
          sx={{ minWidth: 200 }}
        />

        <TextField
          label="Start Date"
          type="date"
          value={salesFilters.startDate}
          onChange={(e) => handleFilterChange('startDate', e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 200 }}
        />

        <TextField
          label="End Date"
          type="date"
          value={salesFilters.endDate}
          onChange={(e) => handleFilterChange('endDate', e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 200 }}
        />

        <Button
          variant="outlined"
          onClick={() => setSalesFilters({
            agent: '',
            product: '',
            startDate: '',
            endDate: ''
          })}
        >
          Clear Filters
        </Button>
      </Box>

      <TableContainer>
        <Table size={isMobile ? 'small' : 'medium'}>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={salesSortConfig.key === 'date'}
                  direction={salesSortConfig.key === 'date' ? salesSortConfig.direction : 'asc'}
                  onClick={() => handleSalesSort('date')}
                >
                  Date
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={salesSortConfig.key === 'agent'}
                  direction={salesSortConfig.key === 'agent' ? salesSortConfig.direction : 'asc'}
                  onClick={() => handleSalesSort('agent')}
                >
                  Agent
                </TableSortLabel>
              </TableCell>
              <TableCell>Products</TableCell>
              <TableCell align="right">Total (GHC)</TableCell>
              <TableCell>Payment Mode</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {getFilteredAndSortedSales()
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((sale) => {
                const total = sale.products.reduce((sum, product) => 
                  sum + (parseFloat(product.price) * parseInt(product.quantity)), 0);
                
                // Get agent name from Redux store using agentId
                const agent = agents_.find(a => a._id === sale.agentId);
                const agentName = agent ? 
                  `${agent.surname || ''} ${agent.lastname || ''} ${agent.othername || ''}`.trim() || agent.name : 
                  'Unknown Agent';
                
                return (
                  <TableRow key={sale.id}>
                    <TableCell>{new Date(sale.date).toLocaleDateString()}</TableCell>
                    <TableCell>{agentName}</TableCell>
                    <TableCell>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Product</TableCell>
                            <TableCell align="right">Quantity</TableCell>
                            <TableCell align="right">Price (GHC)</TableCell>
                            <TableCell align="right">Subtotal (GHC)</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {sale.products.map((product, index) => (
                            <TableRow key={index}>
                              <TableCell>{product.productName}</TableCell>
                              <TableCell align="right">{parseInt(product.quantity).toLocaleString()}</TableCell>
                              <TableCell align="right">GHC {parseFloat(product.price).toFixed(2)}</TableCell>
                              <TableCell align="right">
                                GHC {(parseFloat(product.price) * parseInt(product.quantity)).toFixed(2)}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableCell>
                    <TableCell align="right">
                      <strong>GHC {total.toFixed(2)}</strong>
                    </TableCell>
                    <TableCell>{sale.payment}</TableCell>
                    <TableCell>
                      <IconButton 
                        size="small" 
                        onClick={() => handleViewSaleDetails(sale)}
                        title="View Details"
                      >
                        <AssignmentIcon fontSize="small" />
                      </IconButton>
                      <IconButton 
                        size="small" 
                        onClick={() => editSale(sale)} 
                        disabled={editLoading}
                        title="Edit"
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton 
                        size="small" 
                        onClick={() => deleteSale(sale.id)} 
                        disabled={deleteLoading}
                        title="Delete"
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={getFilteredAndSortedSales().length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );

  // Modify the stock table to include pagination
  const renderStockTable = () => (
    <>
    <TableContainer>
      <Table size={isMobile ? 'small' : 'medium'}>
        <TableHead>
          <TableRow>
            {!isMobile && <TableCell>ID</TableCell>}
            <TableCell>Name</TableCell>
            {!isMobile && <TableCell align="right">Purchase Price (GHC)</TableCell>}
            <TableCell align="right">Selling Price (GHC)</TableCell>
            <TableCell align="right">Quantity</TableCell>
            <TableCell align="right">Total Value (GHC)</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {stocks
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((stock) => {
            const purchasePrice = parseFloat(stock.purchasePrice) || 0;
            const sellingPrice = parseFloat(stock.sellingPrice) || 0;
            const quantity = parseInt(stock.quantity) || 0;
            const totalValue = purchasePrice * quantity;
            
            return (
              <TableRow key={stock.id}>
                {!isMobile && <TableCell>{stock.id}</TableCell>}
                <TableCell>{stock.name}</TableCell>
                {!isMobile && <TableCell align="right">GHC {purchasePrice.toFixed(2)}</TableCell>}
                <TableCell align="right">GHC {sellingPrice.toFixed(2)}</TableCell>
                <TableCell align="right">{quantity.toLocaleString()}</TableCell>
                <TableCell align="right">GHC {totalValue.toFixed(2)}</TableCell>
                <TableCell>
                  <IconButton size="small" onClick={() => editStock(stock)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton 
                    size="small" 
                    onClick={() => deleteStock(stock._id, stock.id)}
                    disabled={deleteStockLoading[stock.id]}
                  >
                    {deleteStockLoading[stock.id] ? (
                      <CircularProgress size={20} />
                    ) : (
                      <DeleteIcon fontSize="small" />
                    )}
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setSelectedStockForAssignment(stock.id);
                      setShowAssignmentDialog(true);
                    }}
                  >
                    <AssignmentIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => handleViewStockHistory(stock)}
                    title="View History"
                  >
                    <HistoryIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={stocks.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );

  // Modify the assignments table to include pagination
  const renderAssignmentsTable = () => {
    const filteredAssignments = stockAssignments.filter(assignment => {
      const matchesAgent = !selectedAgent || assignment.agentId === selectedAgent;
      const matchesStatus = assignmentStatus === 'all' || assignment.status === assignmentStatus;
      
      // Add date filtering
      const assignmentDate = new Date(assignment.assignedAt);
      const startDate = assignmentDateFilters.startDate ? new Date(assignmentDateFilters.startDate) : null;
      const endDate = assignmentDateFilters.endDate ? new Date(assignmentDateFilters.endDate) : null;
      
      const matchesDate = (!startDate || assignmentDate >= startDate) && 
                         (!endDate || assignmentDate <= endDate);
      
      return matchesAgent && matchesStatus && matchesDate;
    });

    const sortedAssignments = sortAssignments(filteredAssignments);

    return (
      <>
      <Box sx={{ mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Filter by Agent</InputLabel>
          <Select
            value={selectedAgent}
            onChange={(e) => setSelectedAgent(e.target.value)}
            label="Filter by Agent"
          >
            <MenuItem value="">All Agents</MenuItem>
            {agents_.map(agent => (
              <MenuItem key={agent._id} value={agent._id}>
                {`${agent.surname || ''} ${agent.lastname || ''} ${agent.othername || ''}`.trim() || agent.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={assignmentStatus}
            onChange={(e) => setAssignmentStatus(e.target.value)}
            label="Status"
          >
            <MenuItem value="all">All Statuses</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="confirmed">Confirmed</MenuItem>
            <MenuItem value="rejected">Rejected</MenuItem>
            <MenuItem value="returned">Returned</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Start Date"
          type="date"
          value={assignmentDateFilters.startDate}
          onChange={(e) => setAssignmentDateFilters(prev => ({ ...prev, startDate: e.target.value }))}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 200 }}
        />
        <TextField
          label="End Date"
          type="date"
          value={assignmentDateFilters.endDate}
          onChange={(e) => setAssignmentDateFilters(prev => ({ ...prev, endDate: e.target.value }))}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 200 }}
        />
        <Button
          variant="outlined"
          onClick={() => {
            setAssignmentDateFilters({ startDate: '', endDate: '' });
            setSelectedAgent('');
            setAssignmentStatus('all');
          }}
        >
          Clear Filters
        </Button>
      </Box>
      <TableContainer>
        <Table size={isMobile ? 'small' : 'medium'}>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={sortConfig.key === 'agentName'}
                  direction={sortConfig.key === 'agentName' ? sortConfig.direction : 'asc'}
                  onClick={() => handleSort('agentName')}
                >
                  Agent
                </TableSortLabel>
              </TableCell>
              <TableCell>Assigned Products</TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortConfig.key === 'status'}
                  direction={sortConfig.key === 'status' ? sortConfig.direction : 'asc'}
                  onClick={() => handleSort('status')}
                >
                  Status
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={sortConfig.key === 'assignedAt'}
                  direction={sortConfig.key === 'assignedAt' ? sortConfig.direction : 'asc'}
                  onClick={() => handleSort('assignedAt')}
                >
                  Date
                </TableSortLabel>
              </TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
              {sortedAssignments
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((assignment) => {
                  // Get agent name from Redux store
                  const agent = agents_.find(a => a._id === assignment.agentId);
                  const agentName = agent ? 
                    `${agent.surname || ''} ${agent.lastname || ''} ${agent.othername || ''}`.trim() || agent.name : 
                    'Unknown Agent';

                  // Get stock details
                  const stock = stocks.find(s => s.id === assignment.stockId);
                  const stockName = stock ? stock.name : 'Unknown Product';
                  const stockPrice = stock ? stock.sellingPrice : 0;
                  const totalValue = stockPrice * assignment.quantity;

                  return (
              <TableRow key={assignment.id}>
                <TableCell>
                        {agentName}
                </TableCell>
                      <TableCell>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell>Product</TableCell>
                              <TableCell align="right">Quantity</TableCell>
                              <TableCell align="right">Price (GHC)</TableCell>
                              <TableCell align="right">Total Value (GHC)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell>{stockName}</TableCell>
                              <TableCell align="right">{assignment.quantity.toLocaleString()}</TableCell>
                              <TableCell align="right">GHC {stockPrice.toFixed(2)}</TableCell>
                              <TableCell align="right">GHC {totalValue.toFixed(2)}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableCell>
                <TableCell>
                  <Chip 
                    label={assignment.status}
                    color={
                      assignment.status === 'confirmed' ? 'success' :
                      assignment.status === 'pending' ? 'warning' :
                      assignment.status === 'rejected' ? 'error' :
                      'default'
                    }
                    size="small"
                  />
                </TableCell>
                <TableCell>{new Date(assignment.assignedAt).toLocaleDateString()}</TableCell>
                <TableCell>
                  {assignment.status === 'pending' && (
                    <>
                      <IconButton 
                        size="small" 
                        onClick={() => handleAssignmentResponse(assignment.id, 'confirmed')}
                        title="Confirm"
                      >
                        <CheckCircleIcon color="success" />
                      </IconButton>
                      <IconButton 
                        size="small" 
                        onClick={() => handleAssignmentResponse(assignment.id, 'rejected')}
                        title="Reject"
                      >
                        <CancelIcon color="error" />
                      </IconButton>
                    </>
                  )}
                  {assignment.status === 'confirmed' && (
                    <>
                      <IconButton 
                        size="small" 
                        onClick={() => handleAssignmentResponse(assignment.id, 'returned')}
                        title="Return"
                      >
                        <UndoIcon />
                      </IconButton>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                          const quantity = prompt('Enter sale quantity:');
                          if (quantity) recordAgentSale(assignment.id, parseInt(quantity));
                        }}
                      >
                        {recordSaleLoading ? 'Recording...' : 'Record Sale'}
                      </Button>
                    </>
                  )}
                </TableCell>
              </TableRow>
                  );
                })}
          </TableBody>
        </Table>
      </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={sortedAssignments.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </>
    );
  };

  // Add new view options
  const viewOptions = [
    { value: 'sales', label: 'Sales' },
    { value: 'stock', label: 'Stock' },
    { value: 'assignments', label: 'Agent Assignments' }
  ];

  // Add sorting function
  const sortAssignments = (assignments) => {
    if (!sortConfig.key) return assignments;

    return [...assignments].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Handle agent name sorting
      if (sortConfig.key === 'agentName') {
        aValue = getAgentFullName(a.agentId);
        bValue = getAgentFullName(b.agentId);
      }

      // Handle date sorting
      if (sortConfig.key === 'assignedAt') {
        aValue = new Date(a.assignedAt);
        bValue = new Date(b.assignedAt);
      }

      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  };

  // Add sort handler
  const handleSort = (key) => {
    setSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  // Assign stock to agent
  const assignStock = async (stockId, agentId, quantity, notes) => {
    try {
      const response = await axios.post('https://server.agrotraciserp.com/api/stock/assignstock/', {
        stockId,
        agentId,
        quantity,
        notes
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  // Get assignments
  const getAssignments = async (filters = {}) => {
    try {
      const response = await axios.post('https://server.agrotraciserp.com/api/stock/getassignments/', filters);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  // Update assignment status
  const updateAssignment = async (stockId, assignmentId, status, notes) => {
    try {
      const response = await axios.post('https://server.agrotraciserp.com/api/stock/updateassignment/', {
        stockId,
        assignmentId,
        status,
        notes
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  // Get assignment history
  const getAssignmentHistory = async (filters = {}) => {
    try {
      const response = await axios.post('https://server.agrotraciserp.com/api/stock/getassignmenthistory/', filters);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  // Add new state for dialog control
  const [openStockDialog, setOpenStockDialog] = useState(false);
  const [openSaleDialog, setOpenSaleDialog] = useState(false);

  // Add dialog handlers
  const handleOpenStockDialog = () => setOpenStockDialog(true);
  const handleCloseStockDialog = () => {
    setOpenStockDialog(false);
    resetStockForm();
  };

  const handleOpenSaleDialog = () => setOpenSaleDialog(true);
  const handleCloseSaleDialog = () => {
    setOpenSaleDialog(false);
    resetSaleForm();
  };

  // Modify the stock form dialog
  const renderStockDialog = () => (
    <Dialog 
      open={openStockDialog} 
      onClose={handleCloseStockDialog}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {editingStock ? 'Edit Stock' : 'Add Stock'}
      </DialogTitle>
      <DialogContent>
        <form onSubmit={editingStock ? updateStock : addStock}>
          <TextField
            fullWidth
            label="Name"
            name="name"
            value={newStock.name}
            onChange={handleStockInput}
            margin="dense"
              size={isMobile ? 'small' : 'medium'}
            required
          />
          <TextField
            fullWidth
            label="Purchase (GHC)"
            name="purchasePrice"
            type="number"
            value={newStock.purchasePrice}
            onChange={handleStockInput}
            margin="dense"
            size={isMobile ? 'small' : 'medium'}
            required
          />
          <TextField
            fullWidth
            label="Selling (GHC)"
            name="sellingPrice"
            type="number"
            value={newStock.sellingPrice}
            onChange={handleStockInput}
            margin="dense"
            size={isMobile ? 'small' : 'medium'}
            required
          />
          <TextField
            fullWidth
            label="Quantity"
            name="quantity"
            type="number"
            value={newStock.quantity}
            onChange={handleStockInput}
            margin="dense"
            size={isMobile ? 'small' : 'medium'}
            required
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseStockDialog}>Cancel</Button>
        <Button 
          onClick={editingStock ? updateStock : addStock}
          variant="contained"
          color="primary"
          disabled={editingStock ? updateLoading : addLoading}
        >
          {editingStock ? (updateLoading ? 'Updating...' : 'Update') : (addLoading ? 'Adding...' : 'Add')}
            </Button>
      </DialogActions>
    </Dialog>
  );

  // Modify the sales form dialog
  const renderSaleDialog = () => (
    <Dialog 
      open={openSaleDialog} 
      onClose={handleCloseSaleDialog}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
                  {editingSale ? 'Edit Sale' : 'Add Sale'}
      </DialogTitle>
      <DialogContent>
                <form onSubmit={editingSale ? updateSale : addSale}>
                  <FormControl fullWidth margin="dense" size={isMobile ? 'small' : 'medium'}>
                    <InputLabel>Agent</InputLabel>
                    <Select
                      label="Agent"
                      value={newSale.agent}
                      onChange={(e) => setNewSale(prev => ({ ...prev, agent: e.target.value }))}
                      required
                    >
                      <MenuItem value="main_office">Main Office</MenuItem>
                      {agents_.map((agent) => (
                        <MenuItem key={agent._id} value={agent._id}>
                  {`${agent.surname || ''} ${agent.lastname || ''} ${agent.othername || ''}`.trim() || agent.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth margin="dense" size={isMobile ? 'small' : 'medium'}>
                    <InputLabel>Payment Mode</InputLabel>
                    <Select 
                      label="Payment Mode" 
                      value={newSale.payment} 
                      onChange={(e) => setNewSale(prev => ({ ...prev, payment: e.target.value }))} 
                      required
                    >
                      <MenuItem value="None">None</MenuItem>
                      <MenuItem value="Momo">Momo</MenuItem>
                      <MenuItem value="Bank">Bank</MenuItem>
                      <MenuItem value="Cash">Cash</MenuItem>
                    </Select>
                  </FormControl>

                  {newSale.products.map((product, index) => (
                    <Box key={index} sx={{ mb: 2, p: 1, border: '1px solid #ddd', borderRadius: 1 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography variant="subtitle2">Product {index + 1}</Typography>
                        {index > 0 && (
                          <IconButton 
                            size="small" 
                            onClick={() => removeProductFromSale(index)}
                            color="error"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        )}
                      </Box>
                  <FormControl fullWidth margin="dense" size={isMobile ? 'small' : 'medium'}>
                    <InputLabel>Product</InputLabel>
                        <Select
                          label="Product"
                          value={product.productId}
                          onChange={(e) => handleProductInput(index, 'productId', e.target.value)}
                          required
                        >
                      <MenuItem value="">Select Product</MenuItem>
                      {stocks.map((stock) => (
                        <MenuItem key={stock.id} value={stock.id}>
                          {stock.name} ({stock.quantity})
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    label="Quantity"
                    type="number"
                        value={product.quantity}
                        onChange={(e) => handleProductInput(index, 'quantity', e.target.value)}
                    margin="dense"
                    size={isMobile ? 'small' : 'medium'}
                    required
                  />
                    </Box>
                  ))}

                  <Button
                    type="button"
                    variant="outlined"
                    onClick={addProductToSale}
                    fullWidth
                    size={isMobile ? 'small' : 'medium'}
                    sx={{ mb: 2 }}
                  >
                    Add Another Product
                  </Button>

                  <TextField
                    fullWidth
                    label="Date Purchased"
                    type="date"
                    value={newSale.date}
                    onChange={(e) => setNewSale(prev => ({ ...prev, date: e.target.value }))}
                    margin="dense"
                    size={isMobile ? 'small' : 'medium'}
                    required
                    InputLabelProps={{ shrink: true }}
                  />

                  {newSale.payment === 'Cash' && (
                    <TextField
                      fullWidth
                      label="Receipt Number"
                      value={newSale.receipt}
                      onChange={(e) => setNewSale(prev => ({ ...prev, receipt: e.target.value }))}
                      margin="dense"
                      size={isMobile ? 'small' : 'medium'}
                    />
                  )}

                  {newSale.payment === 'Momo' && (
                    <>
                      <TextField
                        fullWidth
                        label="Sender's Momo Number"
                        type="tel"
                        value={newSale.sender}
                        onChange={(e) => setNewSale(prev => ({ ...prev, sender: e.target.value }))}
                        margin="dense"
                        size={isMobile ? 'small' : 'medium'}
                      />
                      <TextField
                        fullWidth
                        label="Company Momo Number"
                        type="tel"
                        value={newSale.company}
                        onChange={(e) => setNewSale(prev => ({ ...prev, company: e.target.value }))}
                        margin="dense"
                        size={isMobile ? 'small' : 'medium'}
                      />
                      <TextField
                        fullWidth
                        label="Transaction Number"
                        value={newSale.transaction}
                        onChange={(e) => setNewSale(prev => ({ ...prev, transaction: e.target.value }))}
                        margin="dense"
                        size={isMobile ? 'small' : 'medium'}
                      />
                    </>
                  )}

                  {newSale.payment === 'Bank' && (
                    <>
                      <TextField
                        fullWidth
                        label="Bank Name"
                        value={newSale.bank}
                        onChange={(e) => setNewSale(prev => ({ ...prev, bank: e.target.value }))}
                        margin="dense"
                        size={isMobile ? 'small' : 'medium'}
                      />
                      <TextField
                        fullWidth
                        label="Account Number"
                        value={newSale.account}
                        onChange={(e) => setNewSale(prev => ({ ...prev, account: e.target.value }))}
                        margin="dense"
                        size={isMobile ? 'small' : 'medium'}
                      />
                    </>
                  )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseSaleDialog}>Cancel</Button>
                  <Button
          onClick={editingSale ? updateSale : addSale}
                    variant="contained"
          color="primary"
                    disabled={editingSale ? updateLoading : addLoading}
                  >
                    {editingSale ? (updateLoading ? 'Updating...' : 'Update') : (addLoading ? 'Adding...' : 'Add')}
                  </Button>
      </DialogActions>
    </Dialog>
  );

  // Add delete confirmation dialog component
  const renderDeleteConfirmDialog = () => {
    const stockId = stocks.find(s => s._id === deleteConfirmDialog.stockId)?.id;
    const isLoading = deleteStockLoading[stockId];

    return (
      <Dialog
        open={deleteConfirmDialog.open}
        onClose={() => setDeleteConfirmDialog(prev => ({ ...prev, open: false }))}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Confirm Stock Deletion</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body1" gutterBottom>
              Are you sure you want to delete the stock "{deleteConfirmDialog.stockName}"?
                </Typography>
            {deleteConfirmDialog.hasSales && (
              <Alert severity="warning" sx={{ mt: 2 }}>
                This stock has sales history. Deleting it will also delete all associated sales records.
                This action cannot be undone.
              </Alert>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
                  <Button
            onClick={() => setDeleteConfirmDialog(prev => ({ ...prev, open: false }))}
            color="primary"
          >
            Cancel
          </Button>
          <Button 
                    onClick={() => {
              if (deleteConfirmDialog.stockId) {
                handleDeleteStock(deleteConfirmDialog.stockId, stockId);
              }
            }}
            color="error"
            variant="contained"
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              'Delete'
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  // Add state for edit sale dialog
  const [openEditSaleDialog, setOpenEditSaleDialog] = useState(false);

  // Add delete confirmation dialog state
  const [deleteSaleDialog, setDeleteSaleDialog] = useState({
    open: false,
    saleId: null,
    saleDetails: null
  });

  // Add renderEditSaleDialog function
  const renderEditSaleDialog = () => (
    <Dialog 
      open={openEditSaleDialog} 
      onClose={() => {
        setOpenEditSaleDialog(false);
        resetSaleForm();
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Edit Sale</DialogTitle>
      <DialogContent>
        <form onSubmit={updateSale}>
          <FormControl fullWidth margin="dense" size={isMobile ? 'small' : 'medium'}>
            <InputLabel>Agent</InputLabel>
            <Select
              label="Agent"
              value={newSale.agent}
              onChange={(e) => setNewSale(prev => ({ ...prev, agent: e.target.value }))}
              required
            >
              <MenuItem value="main_office">Main Office</MenuItem>
              {agents_.map((agent) => (
                <MenuItem key={agent._id} value={agent._id}>
                  {`${agent.surname || ''} ${agent.lastname || ''} ${agent.othername || ''}`.trim() || agent.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="dense" size={isMobile ? 'small' : 'medium'}>
            <InputLabel>Product</InputLabel>
            <Select
              label="Product"
              value={product}
              onChange={(e) => setProduct(e.target.value)}
              required
            >
              {stocks.map((stock) => (
                <MenuItem key={stock.id} value={stock.id}>
                  {stock.name} ({stock.quantity})
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Quantity"
            type="number"
            value={newSale.products[0].quantity}
            onChange={(e) => handleProductInput(0, 'quantity', e.target.value)}
            margin="dense"
            size={isMobile ? 'small' : 'medium'}
            required
          />

          <FormControl fullWidth margin="dense" size={isMobile ? 'small' : 'medium'}>
            <InputLabel>Payment Mode</InputLabel>
            <Select 
              label="Payment Mode" 
              value={newSale.payment} 
              onChange={(e) => setNewSale(prev => ({ ...prev, payment: e.target.value }))} 
              required
            >
              <MenuItem value="None">None</MenuItem>
              <MenuItem value="Momo">Momo</MenuItem>
              <MenuItem value="Bank">Bank</MenuItem>
              <MenuItem value="Cash">Cash</MenuItem>
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Date"
            type="date"
            value={newSale.date}
            onChange={(e) => setNewSale(prev => ({ ...prev, date: e.target.value }))}
            margin="dense"
            size={isMobile ? 'small' : 'medium'}
            required
            InputLabelProps={{ shrink: true }}
          />

          {newSale.payment === 'Cash' && (
            <TextField
              fullWidth
              label="Receipt Number"
              value={newSale.receipt}
              onChange={(e) => setNewSale(prev => ({ ...prev, receipt: e.target.value }))}
              margin="dense"
              size={isMobile ? 'small' : 'medium'}
            />
          )}

          {newSale.payment === 'Momo' && (
            <>
              <TextField
                fullWidth
                label="Sender's Momo Number"
                type="tel"
                value={newSale.sender}
                onChange={(e) => setNewSale(prev => ({ ...prev, sender: e.target.value }))}
                margin="dense"
                size={isMobile ? 'small' : 'medium'}
              />
              <TextField
                fullWidth
                label="Company Momo Number"
                type="tel"
                value={newSale.company}
                onChange={(e) => setNewSale(prev => ({ ...prev, company: e.target.value }))}
                margin="dense"
                size={isMobile ? 'small' : 'medium'}
              />
              <TextField
                fullWidth
                label="Transaction Number"
                value={newSale.transaction}
                onChange={(e) => setNewSale(prev => ({ ...prev, transaction: e.target.value }))}
                margin="dense"
                size={isMobile ? 'small' : 'medium'}
              />
            </>
          )}

          {newSale.payment === 'Bank' && (
            <>
              <TextField
                fullWidth
                label="Bank Name"
                value={newSale.bank}
                onChange={(e) => setNewSale(prev => ({ ...prev, bank: e.target.value }))}
                margin="dense"
                size={isMobile ? 'small' : 'medium'}
              />
              <TextField
                fullWidth
                label="Account Number"
                value={newSale.account}
                onChange={(e) => setNewSale(prev => ({ ...prev, account: e.target.value }))}
                margin="dense"
                size={isMobile ? 'small' : 'medium'}
              />
            </>
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          setOpenEditSaleDialog(false);
          resetSaleForm();
        }}>
          Cancel
        </Button>
        <Button 
          onClick={updateSale}
          variant="contained"
          color="primary"
          disabled={updateLoading}
        >
          {updateLoading ? 'Updating...' : 'Update'}
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Add renderDeleteSaleDialog function
  const renderDeleteSaleDialog = () => (
    <Dialog
        open={deleteSaleDialog.open}
        onClose={() => setDeleteSaleDialog({ open: false, saleId: null, saleDetails: null })}
        maxWidth="sm"
        fullWidth
    >
        <DialogTitle>Confirm Sale Deletion</DialogTitle>
        <DialogContent>
            <Box sx={{ mt: 2 }}>
                <Typography variant="body1" gutterBottom>
                    Are you sure you want to delete this sale?
                </Typography>
                {deleteSaleDialog.saleDetails && (
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle2" gutterBottom>
                            Sale Details:
                        </Typography>
                        {deleteSaleDialog.saleDetails.products.map((product, index) => (
                            <Box key={index} sx={{ mb: 1 }}>
                                <Typography variant="body2">
                                    Product: {product.productName}
                                </Typography>
                                <Typography variant="body2">
                                    Quantity: {product.quantity}
                                </Typography>
                                <Typography variant="body2">
                                    Price: GHC {product.price}
                                </Typography>
                            </Box>
                        ))}
                        <Typography variant="body2">
                            Date: {new Date(deleteSaleDialog.saleDetails.date).toLocaleDateString()}
                        </Typography>
                        <Typography variant="body2">
                            Agent: {deleteSaleDialog.saleDetails.agent}
                        </Typography>
                    </Box>
                )}
            </Box>
        </DialogContent>
        <DialogActions>
            <Button 
                onClick={() => setDeleteSaleDialog({ open: false, saleId: null, saleDetails: null })}
                color="primary"
            >
                Cancel
            </Button>
            <Button 
                onClick={handleDeleteSale}
                color="error"
                variant="contained"
                disabled={deleteLoading}
            >
                {deleteLoading ? 'Deleting...' : 'Delete'}
            </Button>
        </DialogActions>
    </Dialog>
  );

  // Add state for view details dialog
  const [viewSaleDialog, setViewSaleDialog] = useState({
    open: false,
    sale: null
  });

  // Add function to handle view details
  const handleViewSaleDetails = (sale) => {
    setViewSaleDialog({
      open: true,
      sale: sale
    });
  };

  // Add renderViewSaleDialog function
  const renderViewSaleDialog = () => (
    <Dialog
      open={viewSaleDialog.open}
      onClose={() => setViewSaleDialog({ open: false, sale: null })}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Sale Details</DialogTitle>
      <DialogContent>
        {viewSaleDialog.sale && (
          <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Product Information
                </Typography>
                <Typography variant="body2">
                  <strong>Product:</strong> {viewSaleDialog.sale.productName}
                </Typography>
                <Typography variant="body2">
                  <strong>Quantity:</strong> {viewSaleDialog.sale.quantity}
                </Typography>
                <Typography variant="body2">
                  <strong>Price:</strong> GHC {parseFloat(viewSaleDialog.sale.price).toFixed(2)}
                </Typography>
                <Typography variant="body2">
                  <strong>Total:</strong> GHC {(parseFloat(viewSaleDialog.sale.price) * parseInt(viewSaleDialog.sale.quantity)).toFixed(2)}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Sale Information
                </Typography>
                <Typography variant="body2">
                  <strong>Date:</strong> {new Date(viewSaleDialog.sale.date).toLocaleDateString()}
                </Typography>
                <Typography variant="body2">
                  <strong>Agent:</strong> {viewSaleDialog.sale.agent}
                </Typography>
                <Typography variant="body2">
                  <strong>Payment Mode:</strong> {viewSaleDialog.sale.payment}
                </Typography>
              </Grid>

              {viewSaleDialog.sale.payment === 'Cash' && viewSaleDialog.sale.receipt && (
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Cash Payment Details
                  </Typography>
                  <Typography variant="body2">
                    <strong>Receipt Number:</strong> {viewSaleDialog.sale.receipt}
                  </Typography>
                </Grid>
              )}

              {viewSaleDialog.sale.payment === 'Momo' && (
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Mobile Money Details
                  </Typography>
                  {viewSaleDialog.sale.sender && (
                    <Typography variant="body2">
                      <strong>Sender's Number:</strong> {viewSaleDialog.sale.sender}
                    </Typography>
                  )}
                  {viewSaleDialog.sale.company && (
                    <Typography variant="body2">
                      <strong>Company Number:</strong> {viewSaleDialog.sale.company}
                    </Typography>
                  )}
                  {viewSaleDialog.sale.transaction && (
                    <Typography variant="body2">
                      <strong>Transaction ID:</strong> {viewSaleDialog.sale.transaction}
                    </Typography>
                  )}
                </Grid>
              )}

              {viewSaleDialog.sale.payment === 'Bank' && (
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Bank Payment Details
                  </Typography>
                  {viewSaleDialog.sale.bank && (
                    <Typography variant="body2">
                      <strong>Bank Name:</strong> {viewSaleDialog.sale.bank}
                    </Typography>
                  )}
                  {viewSaleDialog.sale.account && (
                    <Typography variant="body2">
                      <strong>Account Number:</strong> {viewSaleDialog.sale.account}
                    </Typography>
                  )}
                </Grid>
              )}
            </Grid>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setViewSaleDialog({ open: false, sale: null })}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Add new state for stock history dialog
  const [stockHistoryDialog, setStockHistoryDialog] = useState({
    open: false,
    stock: null
  });

  // Add function to handle viewing stock history
  const handleViewStockHistory = (stock) => {
    setStockHistoryDialog({
      open: true,
      stock: stock
    });
  };

  // Add renderStockHistoryDialog function
  const renderStockHistoryDialog = () => (
    <Dialog
      open={stockHistoryDialog.open}
      onClose={() => setStockHistoryDialog({ open: false, stock: null })}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        Stock History - {stockHistoryDialog.stock?.name}
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Notes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {stockHistoryDialog.stock?.history?.map((entry, index) => (
                <TableRow key={index}>
                  <TableCell>{new Date(entry.date).toLocaleDateString()}</TableCell>
                  <TableCell>
                    <Chip 
                      label={entry.type}
                      color={
                        entry.type === 'add' ? 'success' :
                        entry.type === 'sale' ? 'error' :
                        entry.type === 'update' ? 'warning' :
                        'default'
                      }
                      size="small"
                    />
                  </TableCell>
                  <TableCell>{entry.quantity}</TableCell>
                  <TableCell>{entry.notes || '-'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setStockHistoryDialog({ open: false, stock: null })}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <ThemeProvider theme={theme}>
      <Container sx={{ py: 2 }}>
        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
        
        <Box sx={{ mb: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {viewOptions.map(option => (
            <Button
              key={option.value}
              variant={view === option.value ? 'contained' : 'outlined'}
              onClick={() => setView(option.value)}
                    size={isMobile ? 'small' : 'medium'}
                    sx={{
                backgroundColor: view === option.value ? '#1976d2' : 'transparent',
                color: view === option.value ? 'white' : '#1976d2',
                      '&:hover': {
                  backgroundColor: view === option.value ? '#1565c0' : 'rgba(25, 118, 210, 0.04)',
                      },
                fontWeight: view === option.value ? 600 : 400,
                boxShadow: view === option.value ? 2 : 0,
                    }}
                  >
              {option.label}
                  </Button>
          ))}
                </Box>

        {view === 'sales' && (
          <>
            <Grid item xs={12}>
              <Paper sx={{ p: isMobile ? 1 : 2, overflowX: 'auto' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant={isMobile ? 'h6' : 'h5'}>
                    Sales (GHC{totalSales.toFixed(2)})
                </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenSaleDialog}
                    startIcon={<EditIcon />}
                  >
                    Add Sale
                  </Button>
                </Box>
                {renderSalesTable()}
              </Paper>
            </Grid>
            {renderSaleDialog()}
          </>
        )}
        
        {view === 'stock' && (
          <>
            <Grid item xs={12}>
              <Paper sx={{ p: isMobile ? 1 : 2, overflowX: 'auto' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant={isMobile ? 'h6' : 'h5'}>
                  Stock (GHC{totalStockValue.toFixed(2)})
                </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenStockDialog}
                    startIcon={<EditIcon />}
                  >
                    Add Stock
                  </Button>
                </Box>
                {renderStockTable()}
              </Paper>
            </Grid>
            {renderStockDialog()}
          </>
        )}

        {view === 'assignments' && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Paper sx={{ p: 2 }}>
                {renderAssignmentsTable()}
              </Paper>
            </Grid>
          </Grid>
        )}

        {renderAssignmentDialog()}
        {renderAssignmentHistoryModal()}
        {renderEditAssignmentModal()}
        {renderDeleteConfirmDialog()}
        {renderEditSaleDialog()}
        {renderDeleteSaleDialog()}
        {renderViewSaleDialog()}
        {renderStockHistoryDialog()}
      </Container>
    </ThemeProvider>
  );
}

export default StockSalesManagement;